import { changePasswordActionsStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordActions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

changePasswordActionsStyles.cancelButton = {
    css: css`
        width: 100%;
        border-radius: 25px;
        border: 1px solid ${COLORS.background.black};
        background-color: ${COLORS.background.base};
        > span {
            color: ${COLORS.black} !important;
            font-family: ${TYPOGRAPHY.fontFamily.base};
        }
        &:hover {
            border: 1px solid ${COLORS.background.black};
            background-color: ${COLORS.background.base};
        }
    `,
};

changePasswordActionsStyles.saveButton = {
    css: css`
        width: 100%;
        border-radius: 25px;
        border: 1px solid ${getColor("warning")};
        background-color: ${getColor("warning")};
        > span {
            color: ${getColor("info.contrast")} !important;
            font-family: ${TYPOGRAPHY.fontFamily.base};
        }
        &:hover {
            border: 1px solid ${getColor("warning.contrast")};
            background-color: ${getColor("warning.contrast")};
        }
        &:disabled:hover {
            border: 1px solid ${COLORS.disabled.base};
            background-color: ${COLORS.disabled.base};
        }
    `,
};
